import { FreelancerExportRow } from "../models/FreelancerExportRow";
import { PaginatedResponse } from "../models/Pagination";
import apiClient from "./api-client";
import { handleApiError } from "./error-handler";

export interface FreelancerExportSearchRequest {
  page?: number;
  pageSize?: number;
  name?: string;
  onboardingStatus?: string;
  country?: string;
}

export const getFreelancerExportList = async (
  request: FreelancerExportSearchRequest
): Promise<PaginatedResponse<FreelancerExportRow>> => {
  try {
    const response = await apiClient.post<PaginatedResponse<FreelancerExportRow>>(
      "/freelancer-profiles/export-list",
      request
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error, "Failed to fetch freelancer export list");
  }
};

export const exportFreelancersToExcel = async (
  request: FreelancerExportSearchRequest,
  languageCode: string = "Fr"
): Promise<Blob> => {
  try {
    const response = await apiClient.post(
      `/freelancer-profiles/export-excel?languageCode=${languageCode}`,
      request,
      { responseType: "blob" }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error, "Failed to export freelancers to Excel");
  }
};
